import { EntityMap_PrincipalConnectionFragment } from '../graphql/EntityMap.generated';

export function getGrantorId(g?: EntityMap_PrincipalConnectionFragment | null) {
  return g?.individual?.id;
}
